angular.module('CarsSaraBo').controller('ContractsController', [
	'$scope', '$routeParams', '$location', 'ContractService', "PointOfSaleService","$filter",
	"ContractPublishingService", "NotificationService", "SessionService", "LoadingWheelService",
	"LegalDocumentService",'ContractStatesService',
	function($scope, $routeParams,$location, contractService, pointOfSaleService, $filter,
			 contractPublishingService, notificationService, sessionService, loadingWheelService,
			 legalDocumentService, statesService) {

		function initialize () {
			loadingWheelService.show();
			$scope.showMessageBanner = false;
			$scope.showMessageBannerContractWithoutDocs = false;
			$scope.validations={};
			$scope.contracts= [];
			$scope.config = {
					itemsPerPage:10,
					currentPage:1,
					numPages:0,
					totalItems:0
			};

			$scope.pageContractList = [];

			contractService.query({companyOid: $routeParams.companyOid }, function(response) {
				loadingWheelService.hide();
				$scope.validations.contracts=true;
				$scope.contracts = response;
				$scope.config.totalItems = $scope.contracts.length;
				$scope.config.numPages=Math.floor($scope.contracts.length/$scope.config.itemsPerPage);
				$scope.changePage();
				showMessagesBanner($scope.contracts);
			});

			pointOfSaleService.resource.query({companyOid: $routeParams.companyOid, fields:"name" }, function(pointsOfSale) {
				$scope.pointsOfSale = {};
				for (var p in pointsOfSale) {
					$scope.pointsOfSale[pointsOfSale[p].oid]=pointsOfSale[p].name;
				}
			});

			$scope.order = {field : "" , desc : false};

			$scope.hasCreatePermission = sessionService.loggedUserAllowed('PERM_CONTRACT_CREATE');
			$scope.hasEditPermission = sessionService.loggedUserAllowed('PERM_CONTRACT_EDIT');
			$scope.hasPublishingPermission = sessionService.loggedUserAllowed('PERM_CONTRACT_PUBLISH');
			$scope.role = sessionService.getUserSession().userType;
			$scope.emailExecutiveAccount = '';
		}

		$scope.sort = function(fieldName, desc){

			if($scope.order.field != fieldName){
				$scope.order.field = fieldName;
				$scope.order.desc = desc != undefined ? desc : false;
			} else {
				$scope.order.desc = desc != undefined ? desc : !$scope.order.desc;
			}

			$scope.contracts = $filter('orderBy')($scope.contracts, $scope.order.field, $scope.order.desc);

			$scope.goToFirstPage();
		}

		$scope.goToFirstPage = function (){
			$scope.currentPage = 1;
			$scope.changePage();
		}

		$scope.changePage = function(){
			var startItem = $scope.config.itemsPerPage*$scope.config.currentPage;
			$scope.pageContractList = $scope.contracts.slice(startItem-$scope.config.itemsPerPage, startItem);
		}

		$scope.edit = function(contract) {
			$location.path("/company/" +  $routeParams.companyOid + "/contract/" + contract.oid)
		}

		$scope.create = function() {
			$location.path("/company/" +  $routeParams.companyOid + "/contract/new")
		}

		$scope.getPointsOfSaleNames = function(oids){
			var points = '';
			for (var oid in oids) {
				if($scope.pointsOfSale){
					points+=$scope.pointsOfSale[oids[oid]]+" - ";
				}
			}
			if(points.length>0){
				points = points.substring(0, points.length - 3);
			}
			return points;
		}

		$scope.publishing = function(contract) {
			function togglePublished(contract) {
				contract.published = !contract.published;
			}

			function getPublishingMessage(contract) {
				return contract.published ? "contract.publishing.published" : "contract.publishing.unpublished";
			}

			contractPublishingService.publishing(contract.oid, contract.companyOID, !contract.published)
				.then(function(response) {
					togglePublished(contract);
					// toggle contract.published value first, then show the notification.
					notificationService.notifyInfoByCode(getPublishingMessage(contract));
				});
		};

		function showMessagesBanner(contracts){
			$scope.showMessageBanner = false;
			$scope.showMessageBannerContractWithoutDocs = false;

			if(!!contracts && !!contracts[0]){
				legalDocumentService.query({companyOid: $routeParams.companyOid, contractOid: contracts[0].oid}, function (response) {
					if(!!response && !!response[0]){
						if(isUserRolCompany($scope.role)){
							var legalDocument = response[0];
							$scope.emailExecutiveAccount = contracts[0].businessExecutiveContact;
							$scope.showMessageBanner = statesService.showMessageBanner(legalDocument.state);
							statesService.showNotification(legalDocument.state, legalDocument.daysPassedSinceLastModification);
						}
					}else{
						if(isUserRolDespegar($scope.role)){
							$scope.showMessageBannerContractWithoutDocs = true;
							$scope.contract_name = contracts[0].name;
						}
					}
				});
			}
		}

		function isUserRolCompany(userRole){
			return userRole === 'COMPANY';
		}

		function isUserRolDespegar(userRole){
			return userRole === 'DESPEGAR';
		}

		initialize();
	}
]);


//////////////////
// WEBPACK FOOTER
// ./public/app/contract/contracts_controller.js
// module id = 922
// module chunks = 3